export default __webpack_public_path__ + "static/media/download-curved.f19e097e.svg";